const isMobile = () => {
  const width = window?.innerWidth;
	return width <= 820;
}

export default function CarouselSlider({ swiper, on }) {
  on('beforeInit', () => {
    if (swiper.params.effect !== 'carousel') return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}carousel`);
    const overwriteParams = {
      watchSlidesProgress: true,
      centeredSlides: true,
    };

    Object.assign(swiper.params, overwriteParams);
    Object.assign(swiper.originalParams, overwriteParams);
  });
  on('progress', () => {
    const mql = window.matchMedia("(max-width: 760px)");
    const translateSize = mql.matches ? 49 : 48;
    const modifySize = mql.matches ? -35 : -15;

    if (swiper.params.effect !== 'carousel') return;
    const scaleStep = 0.2;
    const zIndexMax = swiper.slides.length;
    for (let i = 0; i < swiper.slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const slideProgress = swiper.slides[i].progress;
      const absProgress = Math.abs(slideProgress);
      let modify = 1;
      if (absProgress > 1) {
        modify = (absProgress - 1) * 0.2 + 1;
      }
      const opacityEls = slideEl.querySelectorAll(
        '.book-card-animate',
      );
      const translate = `${
        slideProgress * modify * translateSize * (swiper.rtlTranslate ? -1 : 1)
      }%`;
      const rotation = `${
        slideProgress * modify * modifySize * (swiper.rtlTranslate ? -1 : 1)
      }grad`;

      const scale = 1 - absProgress * scaleStep;
      const zIndex = zIndexMax - Math.abs(Math.round(slideProgress));
      // Funcion original
      // slideEl.style.transform = `translateX(${translate}) scale(${scale}) perspective(300px) rotateY(${rotation})`;
      slideEl.style.transform = `translateX(${translate}) scale(${scale}) perspective(300px)`;
      slideEl.style.zIndex = zIndex;

      const children = slideEl.querySelector(".swiper-slide-book-img");
      if (children) {
        children.style.transform = `perspective(300px) rotateY(${rotation})`;
      }
      if (absProgress > 2) {
        slideEl.style.opacity = 0;
      } else {
        slideEl.style.opacity = 1;
      }
      opacityEls.forEach((opacityEl) => {
        opacityEl.style.opacity = 1 - absProgress / 9;
      });
    }
  });

  on('setTransition', (s, duration) => {
    if (swiper.params.effect !== 'carousel') return;
    for (let i = 0; i < swiper.slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const opacityEls = slideEl.querySelectorAll(
        '.book-card-animate',
      );
      slideEl.style.transitionDuration = `${duration}ms`;
      opacityEls.forEach((opacityEl) => {
        opacityEl.style.transitionDuration = `${duration}ms`;
      });
    }
  });
}